<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Kullanıcı</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a>
              <div class="m-dropdown__wrapper" style="z-index: 101;">
                <span
                  class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                  style="left: auto; right: 21.5px;"
                ></span>
                <div class="m-dropdown__inner">
                  <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                      <ul class="m-nav">
                        <li class="m-nav__section m-nav__section--first m--hide">
                          <span class="m-nav__section-text">Quick Actions</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/users'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Kullanıcı Ekle
                  </h3>
                </div>
              </div>
            </div>
                         
            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kullanıcı Tam Adı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.user.fullName.$error }" v-model="user.fullName" class="form-control m-input" placeholder="Kullanıcı Adı giriniz." />
                  </div>
                </div>
              
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kullanıcı Epostası</label>
                    <input type="text"  :class="{ 'is-invalid': $v.user.email.$error }" v-model="user.email" class="form-control m-input" placeholder="Eposta giriniz." />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Sistem Kullanıcı Adı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.user.userName.$error }" v-model="user.userName" class="form-control m-input" placeholder="Sistem Kullanıcı Adı giriniz." />
                  </div>
                </div>


                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Şifre</label>
                    <input type="password"  :class="{ 'is-invalid': $v.user.password.$error }" v-model="user.password" class="form-control m-input" placeholder="Şifre giriniz" />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Şifre Tekrar</label>
                    <input type="password"  :class="{ 'is-invalid': $v.user.repeatPassword.$error }" v-model="user.repeatPassword" class="form-control m-input" placeholder="Tekrar Şifre giriniz" />
                  </div>
                </div>

 

              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="user.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>  
            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import {_create,_getById,_update} from '../../services/UserService'

export default {
created() {
  if(Number(this.$route.params.id)!=0)
        {
          this.user.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
      user:{
        id:0,
        fullName:'',
        email:'',
        userName:'',
        password:'',
        repeatPassword:'',
        tenantId:this.$store.getters.tenantId
      } 
    }

  },
    validations: {
    user: {
      fullName: { required },
           email: { required , email},
           userName: { required },
           password: { required } ,
           repeatPassword: { sameAsPassword: sameAs('password') }
    }
  },
methods: {
  create:function(){
          this.$v.user.$touch();
      if (this.$v.user.$error) return;
          // let loader=this.$loading.show();
    _create(this.user).then(response=>{
      // loader.hide();
      if(response.data.success)
        this.$router.push({ name: 'users' })
    });
  },
  update:function(){
          this.$v.user.$touch();
      if (this.$v.user.$error) return;
    _update(this.user).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'users' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.user=response.data.data;
      else
      this.$router.push({ name: 'users' })
    })
  } 
},
};
</script>